export default {
  common_button_back: 'Späť',
  common_button_cancel: 'Zrušiť',
  common_button_next: 'Ďalej',
  common_button_no: 'Nie',
  common_button_ok: 'OK',
  common_button_reset: 'Reset',
  common_button_skip: 'Preskočiť',
  common_button_yes: 'Áno',
  common_deactivated_message:
    'This kiosk has been activated on another device and is thus no longer active on this one. Please log in again. Thank you!',
  common_deactivated_title: 'Kiosk deactivated on this device',
  common_enterEmail_email: 'Zadajte svoj pracovný e-mail',
  common_enterEmail_title: 'Váš e-mail',
  common_error_message_cameraNotAllowed: 'Ak chcete používať túto funkciu, musíte povoliť prístup k fotoaparátu.',
  common_error_message_ForbiddenException: 'Nedostatočné povolenia',
  common_error_message_incorrectEmail: 'Zadajte správnu e-mailovú adresu',
  common_error_message_invalidCredentials: 'Meno používateľa alebo heslo je neplatné. Skúste to znova.',
  common_error_message_invalidMobile: 'Please enter a valid mobile phone number',
  common_error_message_missingField: 'Povinné pole',
  common_error_message_noInternetConnection: 'Internetové pripojenie sa prerušilo. Skúste to znova.',
  common_error_message_unauthorizedAccess: 'Nepovolený prístup',
  common_error_message_webServiceWrongConnection: 'Počas prenosu dát sa vyskytla chyba. Skúste to znova.',
  common_error_title: 'Chyba',
  common_expired_message:
    'Either your trial has expired or the credit card we have on file stopped working. Please upgrade in order to re-activate the account. Contact sales@proxyclick.com if you have any questions. Thank you!',
  common_expired_title: 'Account expired',
  common_onboarding_login_button: 'Log in',
  common_onboarding_message1: 'Proxyclick helps you singleTenantWelcome your visitors exactly the way you want to.',
  common_onboarding_message2:
    'Brand your check-in process and your badges, and ask your visitors only the questions that apply to them.',
  common_onboarding_message3: 'Hosts get notified when their guests arrive and can reply instantly.',
  common_onboarding_message4:
    'Protect your facilities and ensure compliance through emergency lists, watch lists, NDAs, privacy rules ...',
  common_onboarding_message5:
    'Proxyclick does the hard work so you can singleTenantWelcome your visitors with a smile.',
  common_placeholder_optional: 'Voliteľné',
  common_setup_activationCode_activate_button: 'Activate',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'Eg. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Invalid activation code',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_title: 'Activate kiosk with unique code',
  common_setup_device_footer: 'Na vytvorenie nového kiosku sa pripojte k webovej aplikácii Proxyclick',
  common_setup_device_locked_content:
    'Tento kiosk sa už používa na inom zariadení iPad. Jeho nastavením na zariadení iPad, ktoré máte v rukách, ho deaktivujete na druhom zariadení. Skutočne chcete nastaviť tento kiosk na tomto zariadení iPad?',
  common_setup_device_locked_continue_button: 'Nastaviť tento kiosk',
  common_setup_device_locked_title: 'Kiosk sa už používa',
  common_setup_device_multiTenants: 'Multi-spoločnosti',
  common_setup_device_title: 'Vyberte si svoj kiosk',
  common_setup_loading_footer: 'na prispôsobenie svojho kiosku sa pripojte k webovej aplikácii Proxyclick.',
  common_setup_loading_message: 'Prebieha konfigurácia...',
  common_setup_loading_title: 'Váš kiosk sa nastavuje...',
  common_setup_location_footer: 'Na vytvorenie novej lokality sa pripojte k webovej aplikácii Proxyclick.',
  common_setup_location_kiosk: 'kiosk',
  common_setup_location_kiosks: 'kiosky',
  common_setup_location_title: 'Vyberte lokalitu',
  common_setup_login_activationCode_button: 'Activate with unique code?',
  common_setup_login_email: 'E-mail',
  common_setup_login_forgotPassword_button: 'Zabudli ste heslo?',
  common_setup_login_password: 'Heslo',
  common_setup_login_title: 'Prihlásiť sa pomocou účtu Proxyclick',
  common_setup_ready_header: 'Ste pripravení nastaviť toto zariadenie iPad ako svoj kiosk {0}?',
  common_setup_ready_message:
    'Konfigurácia trvá len niekoľko minút a váš kiosk bude plne funkčný pripravený na používanie.',
  common_setup_ready_setup_button: 'Nastaviť',
  common_setup_ready_title: 'Dobrý deň, {0}',
  common_signup_company: 'Spoločnosť',
  common_signup_email: 'E-mail',
  common_signup_error_name: 'Zadajte meno a priezvisko',
  common_signup_loading_message1:
    'Pripojením k webovej aplikácii Proxyclick si môžete svoj kiosk upraviť. Práve sme vám poslali e-mail so všetkými informáciami.',
  common_signup_loading_message2:
    'Prostredníctvom webovej stránky si môžete nastaviť tlačiareň na tlačenie visačiek pri registrácii.',
  common_signup_loading_message3:
    'Môžete tiež nastaviť odosielanie upozornení hostiteľovi pri registrácii návštevníka.',
  common_signup_loading_message4: 'A nastaviť vlastnú farebnosť a uvítací obrázok kiosku.',
  common_signup_loading_title: 'Váš účet sa nastavuje…',
  common_signup_name: 'Meno',
  common_signup_name_placeholder: 'Meno Priezvisko',
  common_signup_password: 'Heslo',
  common_signup_title: 'Vitajte v systéme Proxyclick',
  common_signup_tryFree_button: 'Odoslať',
  common_timeout_content: 'Kliknutím zrušte',
  common_timeout_title: 'Návrat na domovskú obrazovku',
  common_tooltip_disable_button: 'Vypnúť všetky popisy',
  common_tooltip_gotIt_button: 'Chápem',
  dm_delivery_confirmation_knownRecipient: 'Používateľ {{Host_Name}} bol informovaný, že ste dostali balík',
  dm_delivery_confirmation_title: 'Ďakujeme!',
  dm_delivery_confirmation_unknownRecipient:
    'Bolo vám poslané upozornenie, aby ste informovali {{Company_Name}}, že ste im doručili balík',
  dm_delivery_recipient_name: 'Pre koho je tento balík určený?',
  dm_delivery_recipient_unknown_button: 'Neviem',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_confirmation_header_withoutPrint: 'Ste zaregistrovaní!',
  vm_checkin_confirmation_header_withPrint: 'Prebieha tlač vašej visačky',
  vm_checkin_confirmation_message: 'Posaďte sa, prosím. {{Host_FirstName}} sa vám bude hneď venovať.',
  vm_checkin_confirmation_takeBackID: "Please don't forget your ID",
  vm_checkin_confirmation_title: 'Ďakujeme!',
  vm_checkin_details_companyName: 'Spoločnosť',
  vm_checkin_details_email: 'E-mail',
  vm_checkin_details_firstname: 'Meno',
  vm_checkin_details_lastname: 'Priezvisko',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_error_message_unableToCheckIn:
    'Pri dokončení vašej registrácie sa vyskytla chyba. Obráťte sa, prosím, na recepciu.',
  vm_checkin_flow_company: 'Spoločnosť',
  vm_checkin_flow_duration: 'Visit duration',
  vm_checkin_flow_email: 'E-mail',
  vm_checkin_flow_error_message_imageNotAvailable:
    'Obrázok momentálne nie je k dispozícii (problém s internetovým pripojením)',
  vm_checkin_flow_licensePlate: 'ŠPZ',
  vm_checkin_flow_mobile: 'Zadajte svoje mobilné číslo',
  vm_checkin_flow_mobile_info: 'Toto sa použije na spojenie s vami v prípade núdze, keď ste v zariadení',
  vm_checkin_flow_tooltip_content:
    'Opýtajte sa svojich návštevníkov na všetko, čo potrebujete na zlepšenie ich dojmov alebo na vyššie zabezpečenie vášho procesu registrácie. Tok otázok môžete meniť podľa odpovedí návštevníka. Zobrazené otázky sú len predvádzacie ukážky.',
  vm_checkin_flow_tooltip_title: 'Inteligentné otázky',
  vm_checkin_host_enterFullName: 'Zadajte celé meno svojho hostiteľa',
  vm_checkin_host_name: 'Koho ste prišli navštíviť?',
  vm_checkin_host_notListed_block:
    'Ak nepoznáte meno svojho hostiteľa alebo ste ho nenašli v zozname, obráťte sa na pracovníka recepcie.',
  vm_checkin_host_notListed_continue: 'Nie je v zozname',
  vm_checkin_host_tooltip_content:
    'Sem zadajte svoje meno a my vám pošleme e-mail s upozornením, ktorý dostanú vaši zamestnanci, keď príde ich návštevník.',
  vm_checkin_host_tooltip_title: 'Upozornenie o príchode návštevníka',
  vm_checkin_host_unknown_button: 'Neviem',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_header: 'Please scan your ID',
  vm_checkin_idScan_aila_learnMore: 'Learn more',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_back_picture_header_aila: 'Place your ID in the holder so the back faces the camera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Position the back of your ID entirely inside the frame.',
  vm_checkin_idScan_back_picture_take_button: 'Scan back',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_idScan_cancel_title: 'Warning',
  vm_checkin_idScan_disclaimer_start_button: "Let's get started",
  vm_checkin_idScan_disclaimer_text:
    'As part of our security policy, we need to verify your identity using your ID. \n\nWe value your privacy, so we will not store the picture of your ID. Reception officers are available to help if you have any questions.',
  vm_checkin_idScan_editName_title: 'Please fill in your first and last name',
  vm_checkin_idScan_front_picture_header_aila: 'Place your ID in the holder so the front faces the camera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Position your ID entirely inside the frame.',
  vm_checkin_idScan_front_picture_take_button: 'Scan front',
  vm_checkin_idScan_match_check: 'Comparing the two pictures',
  vm_checkin_idScan_match_confirm_button: 'Confirm',
  vm_checkin_idScan_match_error_default_header: 'Sorry, something went wrong.',
  vm_checkin_idScan_match_error_default_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idExpired_header: 'Sorry, your ID seems to have expired.',
  vm_checkin_idScan_match_error_idExpired_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Sorry, we could not identify a face on your ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Sorry, we could not identify a face on the picture you took.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_region_0: ' United States',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'South America',
  vm_checkin_idScan_region_3: ' Europe',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Asia',
  vm_checkin_idScan_region_6: ' General Documents',
  vm_checkin_idScan_region_7: ' Africa',
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_instructions_agreeTerms_button: 'Súhlasím',
  vm_checkin_instructions_clearSignature_button: 'Vymazať',
  vm_checkin_instructions_sendCopy_button: 'Pošlite mi kópiu e-mailom',
  vm_checkin_instructions_sendCopyTo_button: 'Kópia sa odošle na {0} (zmeniť)',
  vm_checkin_instructions_sign: 'Zaregistrujte sa tu pomocou svojho prstu',
  vm_checkin_instructions_tooltip_content:
    'Umožnite svojim návštevníkom vyjadriť súhlas s pokynmi pre návštevníkov jednoduchým dotykom alebo podpisom. Pokyny môžete prispôsobiť rôznym typom registrujúcich sa návštevníkov. Túto funkciu a mnohé ďalšie môžete upraviť prostredníctvom ovládacieho panela aplikácie Proxyclick.',
  vm_checkin_instructions_tooltip_title: 'Odoslané',
  vm_checkin_method_name: 'Dobrý deň. Ako sa voláte?',
  vm_checkin_method_name_enterFullName: 'Zadajte svoje celé meno',
  vm_checkin_method_name_invitationQuestion: 'Did you receive an invitation with a QR-code?',
  vm_checkin_method_name_notRegistered_block: 'Nie ste v zozname? Obráťte sa na recepciu.',
  vm_checkin_method_name_notRegistered_continue: 'Nie ste v zozname?',
  vm_checkin_method_tooltip_content:
    'Ak chcete zistiť, ako sa rozoznávajú stáli a vopred registrovaní návštevníci, zaregistrujte sa ako „Justin Diaz“.',
  vm_checkin_method_tooltip_title: 'Rozoznávanie návštevníka',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_pictureTaken: 'Picture taken',
  vm_checkin_picture_auto_stayStill: 'Remain still',
  vm_checkin_picture_take_button: 'Odfotiť',
  vm_checkin_picture_title: 'Teraz vás odfotíme.',
  vm_checkin_picture_tooltip_content:
    'Svoj kiosk môžete prispôsobiť svojim potrebám a jednoducho doň pridávať alebo odoberať funkcie ako fotografovanie návštevníkov a tlač visačiek.',
  vm_checkin_picture_tooltip_title: 'Voliteľné funkcie',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_checkin_returning_email: "Hello, what's your email address?",
  vm_checkin_returning_email_notRegistered:
    'We could not find a scheduled visit linked to your email address. Please check with reception or try again with a different email address.',
  vm_checkin_saveInfo_email: 'Save my info to speed up my next check-in',
  vm_checkin_saveInfo_email_placeholder: 'Enter your email address',
  vm_checkin_saveInfo_title: 'Enter your email',
  vm_checkin_summary_agreementAlreadySigned: 'Agreement already signed',
  vm_checkin_summary_checkin_button: 'Zaregistrovať sa',
  vm_checkin_summary_countDown: 'You will be checked in after',
  vm_checkin_summary_editDetails_button: 'Upraviť podrobnosti',
  vm_checkin_summary_groupStats: 'Počet už prítomných osôb: {0} z {1}',
  vm_checkin_summary_meetingTime: 'Stretnutie o {0}',
  vm_checkin_summary_reviewDetails_button: 'Skontrolovať podrobnosti mojej návštevy',
  vm_checkin_summary_sendPass_button: 'Pošlite mi preukaz do môjho telefónu na účely budúcich návštev',
  vm_checkin_summary_sendPassTo_button: 'Trvalý vstupný preukaz, sa odošle na {0} (zmeniť)',
  vm_checkin_summary_takeNewPicture_button: 'Znovu odfotografovať',
  vm_checkin_summary_title: 'Vaša návšteva v spoločnosti {{Company_Name}}',
  vm_checkin_summary_visiting: 'Stretnutie s {0}',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_welcome_firstTime: 'Vitajte, {{Visitor_FirstName}}!',
  vm_checkin_welcome_lastVisit_date: 'Your last visit was on {0}',
  vm_checkin_welcome_lastVisit_today: 'Your last visit was earlier today',
  vm_checkin_welcome_lastVisit_yesterday: 'Your last visit was yesterday',
  vm_checkin_welcome_returning: 'Vitajte opäť u nás, {{Visitor_FirstName}}!',
  vm_checkout_confirmation_header: 'Dovidenia, {{Visitor_FirstName}}!',
  vm_checkout_confirmation_message: 'Boli ste odhlásení. Dúfame, že sa vám počas vašej návštevy páčilo.',
  vm_checkout_confirmation_title: 'Ďakujeme za vašu návštevu!',
  vm_checkout_method_name: 'Zadajte svoje meno na odhlásenie',
  vm_checkout_method_name_notFound: 'Nie je možné nájsť',
  vm_checkout_method_title: 'Odhlásenie',
  vm_identification_id_button: 'Naskenujte svoj preukaz totožnosti',
  vm_identification_qrCode_button: 'Naskenujte svoju pozvánku alebo preukaz',
  vm_infopack_confirmation: 'Ďakujeme! Informácie sme poslali na {0}.',
  vm_infopack_email: 'Zadajte svoj e-mail, aby sme vám mohli poslať informácie o aplikácii Proxyclick',
  vm_infopack_likeCheckIn: 'Liked this check-in? Tap here to learn more',
  vm_infopack_likeProcess: 'Liked this process? Tap here to learn more',
  vm_infopack_send_button: 'Pošlite mi informácie',
  vm_multiTenant_title: 'Vitajte. Ktorú spoločnosť ste prišli navštíviť?',
  vm_product_footer_learnMore: 'Learn more',
  vm_product_footer_noPartner: "You're using Proxyclick Welcome",
  vm_product_footer_partner: "You're using Proxyclick Welcome, brought to you by {0}",
  vm_qrCode_help: 'Podržte svoj kód vo vzdialenosti 10-15 cm pred kamerou.',
  vm_qrCode_not_recognized: 'Kód nebolo možné rozoznať.',
  vm_qrCode_title: 'Naskenujte svoju visačku alebo kód Passbook.',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>POKYNY PRE NÁVŠTEVNÍKOV A DOHODA O MLČANLIVOSTI</h1><p>Vitajte! Je nám cťou privítať vás ako hosťa spoločnosti {{Company_Name}} v našich priestoroch.</p><h2>Pokyny týkajúce sa bezpečnosti a ochrany zdravia</h2><p>Počas vášho pobytu sme zodpovední za vašu osobnú bezpečnosť. Z tohto dôvodu vás prosíme o dodržiavanie týchto pokynov:</p><ul><li><b>Vstup do priestorov</b> je povolený len v sprievode zamestnanca spoločnosti {{Company_Name}}</li><li>Je potrebné neustále nosiť <b>visačku návštevníka</b> a pri odchode ju vrátiť na recepcii</li><li>V <b>núdzových situáciách</b> musia všetci návštevníci ihneď opustiť priestory najbližším núdzovým východom a hlásiť sa na určenom zhromaždisku</li><li>Návštevníkom sa <b> zakazuje fotografovať a nahrávať video</b> čohokoľvek vo vnútorných priestoroch a v okolí prevádzky</li><li>Vo vnútri budovy je <b>fajčenie prísne zakázané</b> </li></ul><h2>Dohoda o mlčanlivosti</h2><p>Počas vašej návštevy prevádzky spoločnosti {{Company_Name}} môžete prísť do styku s obchodným tajomstvom alebo dôvernými informáciami (okrem iného vrátane informácií súvisiacich s technológiami, procesmi, vybavením, schémami a špecifikáciami), ktoré verejnosti nie sú prístupné (ďalej súhrnne označované ako &#34;Dôverné informácie&#34;).</p><p>V súvislosti s posúdením vašej návštevy prevádzky spoločnosti {{Company_Name}} a ďalšími povoleniami vám udelenými súhlasíte, že </p><p>(a) Nezverejníte ani inak neposkytnete žiadne dôverné informácie, ktoré vám boli počas tejto i ďalších návštev poskytnuté; or</p><p>(b) Nepoužijete, nebudete pomáhať iným s používaním ani ďalším využitím dôverných informácií akýmkoľvek spôsobom.</p><p>(c) Nepoužijete fotoaparáty alebo video technológie na zverejnenie dôverných informácií.</p><p>Zaregistrovaním sa v týchto priestoroch súhlasíte a rozumiete týmto pokynom týkajúcich sa bezpečnosti a ochrany zdravia a dohode o mlčanlivosti.</p>',
  vm_signup_defaultInstruction_name: 'Pokyny musia podpísať všetci návštevníci',
  vm_signup_defaultInstruction_title: 'Prečítajte si ich a podpíšte sa nižšie',
  vm_vaccine_certification_accessDenied_button: 'Okay',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_welcome_changeLanguage_button: 'Change Language',
  vm_welcome_checkin_button: 'Zaregistrovať sa',
  vm_welcome_checkout_button: 'Odhlásiť sa',
  vm_welcome_delivery_button: 'Delivery',
  vm_welcome_hello_line1: 'Dobrý deň,',
  vm_welcome_hello_line2: 'v spoločnosti {{Company_Name}}',
  vm_welcome_qrCode_checkedIn: "Welcome {0}, don't forget to check out before leaving",
  vm_welcome_qrCode_checkedOut: 'Thank you for visiting, {0}!',
  vm_welcome_qrCode_notRecognized: 'This QR code is not recognized. Please try again.',
  vm_welcome_qrCode_scan: 'Pre-registered Visitors: hold your QR code up to the camera for check-in or out',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_returning_button: 'Been here before?',
  vm_welcome_title: 'Vitajte v spoločnosti {{Company_Name}}',
  vm_welcome_tooltip_content:
    'Na prispôsobenie svojho kiosku sa prihláste do webovej aplikácii Proxyclick. Práve sme vám poslali e-mail s pokynmi. Vo webovej aplikácii si môžete nahrať svoje logo, obrázok pozadia a zvoliť si farebnosť tak, aby váš kiosk odrážal vašu obchodnú identitu.',
  vm_welcome_tooltip_title: 'Upraviť podľa seba',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scan this QR code with Proovr (employees) or your phone (visitors) to check in',
  vm_welcome_touchless_unexpected_qrCode_show: 'Scan this QR code with your phone to check in as a visitor',
  common_or: 'alebo',
};
